// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 16", width: "16", height: "16" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", { fillRule: "nonzero" },
                React.createElement("path", { d: "M839.684,493.030667 L838,499 L843.969333,497.316 L850.659333,490.626 L846.374,486.340667 L839.684,493.030667 Z M853.112,483.888 C852.54,483.315333 851.778667,483 850.969333,483 C850.16,483 849.398667,483.315333 848.826667,483.888 L847.318667,485.396 L851.604,489.681333 L853.112,488.173333 C853.684667,487.601333 854,486.84 854,486.030667 C854,485.220667 853.684667,484.46 853.112,483.888 Z", transform: "translate(-838 -483)" })))));
};
Icon.displayName = 'Pencil16x16';
export default Icon;
//# sourceMappingURL=Pencil16x16.js.map